import React, {useEffect, useState} from 'react';
import './App.css';
import {Route, Routes,} from "react-router-dom";
import ChartComponent from "./components/ChartComponent";
import TestComponent from "./components/TestComponent";
import FeedComponent from "./components/FeedComponent";
import SGBComponent from "./components/sgb/SGBComponent";
import EquityWatchComponent from "./components/EquityWatchComponent";
import NavigationComponent from "./components/NavigationComponent";
import OptionComponent from "./components/options/OptionComponent";
import LookSellExchange from "./components/sgb/LookSellExchange";
import {close,init} from "./util/WebsocketClient";
import { registerPushNotifications } from "./util/PushNotificationUtil";
import {SGBReportComponent} from "./components/report/SGBReportComponent";
import AppConstants from "./util/AppConstants";
import ComboOrdersComp from "./components/options/ComboOrdersComp";
import {Toaster} from "react-hot-toast";
import MarginsComponent from "./components/MarginsComponent";
import GatewayService from "./service/GatewayService";
import {AppClients} from "./models/AppClients";
import { ClientsProvider } from "./context/ClientsContext";
import { ChainProvider } from "./context/ChainContext";
import LoginComponent from "./components/LoginComponent";
import ContractNoteComponent from "./components/ContractNoteComponent";
import BondsComponent from "./components/bonds/BondsComponent";
import MissedOppComponent from "./components/options/MissedOppComponent";
import CarryForwardComponent from "./components/report/CarryForwardComponent";
import ClosingPriceComponent from "./components/report/ClosingPriceComponent";
import McxDevolvementComponent from "./components/report/McxDevolvementComponent";
import ClientReportComponent from "./components/report/ClientReportComponent";
import SqOffComponent from "./components/options/SqOffComponent";
import AllOptionComponent from "./components/options/AllOptionsComponent";
// import AppConfigComponent from "./components/AppConfigComponent";
import TradeAnalyzerComponent from "./components/options/TradeAnalyzerComponent";
import TodayTradesComponent from "./components/options/TodayTradesComponent";
var timer: NodeJS.Timeout
function onchange (evt:any) {
    if(evt.target["hidden"]){
    //     gone
        timer = setTimeout(()=>{
            if(document["hidden"])close()
        },1000*60*10)
    }else{
        clearTimeout(timer)
    //     came back
    //     init()
    }
}

const App = () =>{
    const [clients, setClients] = useState<AppClients | null>(null);

    useEffect(()=>{
        document.addEventListener("visibilitychange", onchange);

        // Fetch clients when app loads
        GatewayService.getClients().then(setClients).catch(console.error);

        registerPushNotifications().catch(console.error);
    }, [])
    
    return <>
        <div><Toaster/></div>
        <ClientsProvider clients={clients?.clients || []}>
            <ChainProvider>
                <NavigationComponent/>
                <Routes>
                    <Route path="/" element={<LoginComponent/>}></Route>
                    <Route path="/sgb" element={<SGBComponent/>}></Route>
                    <Route path="/report/sgb" element={<SGBReportComponent/>}></Route>
                    <Route path="/chart" element={<ChartComponent/>}></Route>
                    {/*<Route path="/config" element={<AppConfigComponent/>}></Route>*/}
                    <Route path="/feed" element={<FeedComponent/>}></Route>
                    <Route path="/equity" element={<EquityWatchComponent/>}></Route>
                    <Route path="/option/type/:type" element={<OptionComponent/>}></Route>
                    <Route path="/option" element={<AllOptionComponent/>}></Route>
                    {/*<Route path="/option" element={<OptionComponent/>}></Route>*/}
                    <Route path="/orders" element={<ComboOrdersComp/>}></Route>
                    <Route path="/missed" element={<MissedOppComponent/>}></Route>
                    <Route path="/square-off" element={<SqOffComponent/>}></Route>
                    <Route path="/sgb/sell" element={<LookSellExchange/>}></Route>
                    <Route path="/test" element={<TestComponent/>}></Route>
                    <Route path="/margins" element={<MarginsComponent/>}></Route>
                    <Route path="/bonds" element={<BondsComponent/>}></Route>
                    <Route path="/contract/note" element={<ContractNoteComponent/>}></Route>
                    <Route path="/report/position" element={<CarryForwardComponent/>}></Route>
                    <Route path="/report/closing" element={<ClosingPriceComponent/>}></Route>
                    <Route path="/report/mcx-devolvement" element={<McxDevolvementComponent/>}></Route>
                    <Route path="/report/client" element={<ClientReportComponent/>}></Route>
                    <Route path="/trade-analyzer" element={<TradeAnalyzerComponent/>}></Route>
                    <Route path="/today-trades" element={<TodayTradesComponent/>}></Route>
                </Routes>
            </ChainProvider>
        </ClientsProvider>
    </>
}
export default App;
